/**
 * @file messagesConstants.js
 * @description Constants for the Messages module.
 *              Includes UI label strings, table configurations, messages, and error constants.
 *
 * @module messagesConstants
 *
 * @exports MESSAGE_STRINGS   - UI label strings for the message panel.
 * @exports MESSAGE_KEYS      - Key mappings for message data.
 * @exports MESSAGE_TABLE_COLUMNS - Column definitions for the message table.
 * @exports MESSAGE_TABLE_COLUMN_KEYS - Column key mappings for the message table.
 * @exports UPCOMING_MESSAGE_TABLE_COLUMNS - Column definitions for the upcoming message table.
 * @exports UPCOMING_MESSAGE_TABLE_COLUMN_KEYS - Column key mappings for the upcoming message table.
 * @exports MESSAGE_MESSAGES  - Message strings for message operations.
 * @exports MESSAGE_ERRORS    - Error message strings for message data fetching.
 */
export const MESSAGE_STRINGS = {
    MESSAGES: "Messages",
    SEARCH_PAGE: "Search Page",
    SEARCH_MESSAGES: "Search Messages",
    SAVE_MESSAGES: "Save Schedule",
    UPCOMING: "Upcoming",
    MODULE: "Module",
    PAGE: "Page"
};

export const MESSAGE_KEYS = {
    MESSAGE_NAME: "ID"
}

export const MESSAGE_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions"},
    { id: "msg_scheduled_at", isSortable: true, label: "Date"},
    { id: "customer", isSortable: true, label: "Customer"},
    { id: "campaignSchedulemsg", isSortable: true, label: "Message"},
    { id: "channeltype", isSortable: true, label: "Channel"},
];

export const MESSAGE_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    MESSAGE_DATE: "msg_scheduled_at",
    CUSTOMER: "customer",
    MESSAGE: "campaignSchedulemsg",
    CHANNEL: "channeltype",
    ENABLED: "Inactive",
};

export const UPCOMING_MESSAGE_TABLE_COLUMNS = [
    { id: "msg_scheduled_at", isSortable: false, label: "Date"},
    { id: "customerId", isSortable: false, label: "Customer ID"},
    { id: "campaignSchedulemsg", isSortable: false, label: "Message"},
    { id: "channeltype", isSortable: false, label: "Channel"},
    { id: "timezone", isSortable: false, label: "Timezone"},
    { id: "msg_sent", isSortable: false, label: "Status"},
    { id: "campaignname", isSortable: false, label: "Campaign"},
    { id: "CampaignScheduleName", isSortable: false, label: "Schedule"},
];

export const UPCOMING_MESSAGE_TABLE_COLUMN_KEYS = {
    MESSAGE_DATE: "msg_scheduled_at",
    CUSTOMER_ID: "customerId",
    MESSAGE: "campaignSchedulemsg",
    CHANNEL: "channeltype",
    TIMEZONE: "timezone",
    MESSAGE_SENT: "msg_sent",
    CAMPAIGN: "campaignname",
    SCHEDULE: "CampaignScheduleName",
};

export const MESSAGE_MESSAGES = {
    NO_MESSAGES: "No messages to display",
    NO_PAGES: "No pages found for this message.",
    MESSAGE_UPDATED: "Message updated successfully!"
};

export const MESSAGE_ERRORS = {
    FETCH_MESSAGES_ERROR: "Error fetching messages.",
    MESSAGE_UPDATE_FAILED: "Failed to update message.",
};